import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TrackContainer from "./TrackContainer";
import { selectRole } from "./infoSlice";
import { selectEventsData, setEventData } from "../events/eventsSlice";
import { useMemo } from "react";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";

const TimeTrack = ({ history }) => {
  const { t } = useTranslation();
  const role = useSelector(selectRole);
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const timeOptions = useMemo(() => {
    switch (role) {
      case "Partner":
      case "Kid":
      case "Friend":
      case "Sibling":
      case "Grandparent":
      default:
        return [
          {
            id: 0,
            imgPath: ('../assets/how_often/every_hour.png'),
            name: t("every_hour"),
            value: 'Hourly'
          },
          {
            id: 1,
            imgPath: ('../assets/how_often/every_day.png'),
            name: t("every_day"),
            value: 'Daily'
          },
          {
            id: 2,
            imgPath: ('../assets/how_often/once_a_week.png'),
            name: t("once_week"),
            value: 'Weekly'
          },
          {
            id: 3,
            imgPath: ('../assets/how_often/rarely.png'),
            name: t("rarely"),
            value: 'Rarely'
          },
          {
            id: 4,
            imgPath: ('../assets/how_often/never.png'),
            name: t("never"),
            value: 'Never'
          },
        ];
    }
  }, [t, role]);

  const onSingleClick = (howOften) => {
    dispatch(setEventData({ id: "Frequency", data: howOften }));
    sendAnalyticsEvents(EVENTS.onboardingCheckTimeSubmitted, {
      ...eventsData,
      Frequency: howOften,
    });
    history.push(`/choose-frequency`);
  };

  return (
    <TrackContainer
      pageEvent={"onboardingCheckTimeShown"}
      title={
        role === "Other"
          ? t("question4_other")
          : t("question4_title", { role: role.toLowerCase() })
      }
      options={timeOptions}
      onSingleClick={onSingleClick}
      nextPage={'choose-frequency'}
    />
  );
};

export default TimeTrack;
